import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

const base = `${config["apiUrl"]}serviceOrders/hisense`;

function handle(promise) {
  return promise
    .then((response) => (response.status === 200 ? response.data : null))
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.log("HISENSE ERROR:: ", error.response ? error.response.data : error);
      return error.response ? error.response.data : null;
    });
}

class HisenseService {
  syncFromApi() {
    return handle(axios.get(base, { headers: authHeader() }));
  }

  listAccepted() {
    return handle(axios.get(`${base}/list/accepted`, { headers: authHeader() }));
  }

  countAccepted() {
    return handle(axios.get(`${base}/list/accepted/count`, { headers: authHeader() }));
  }

  listWithoutPat() {
    return handle(axios.get(`${base}/list/withoutPat`, { headers: authHeader() }));
  }

  countWithoutPat() {
    return handle(axios.get(`${base}/list/withoutPat/count`, { headers: authHeader() }));
  }

  listForAccepted() {
    return handle(axios.get(`${base}/list/forAccepted`, { headers: authHeader() }));
  }

  countForAccepted() {
    return handle(axios.get(`${base}/list/forAccepted/count`, { headers: authHeader() }));
  }

  createPat(id) {
    return handle(axios.patch(`${base}/${id}/createPat`, {}, { headers: authHeader() }));
  }

  getByPatId(patId) {
    return handle(axios.get(`${base}/pat/${patId}`, { headers: authHeader() }));
  }

  updateServiceOrder(id, payload) {
    return handle(axios.patch(`${base}/${id}/update`, payload, { headers: authHeader() }));
  }

  listSpareParts(id) {
    return handle(axios.get(`${base}/${id}/parts`, { headers: authHeader() }));
  }

  requestSpareParts(id, payload) {
    return handle(axios.post(`${base}/${id}/parts`, payload, { headers: authHeader() }));
  }

  pollSparePartsOrder(id, partsOrderId) {
    return handle(
      axios.post(`${base}/${id}/parts/${partsOrderId}/poll`, {}, { headers: authHeader() })
    );
  }
}

export default new HisenseService();
